<template>
  <tr>
    <td
      style="width: 25px;border-bottom: 0;"
      @mouseover="hovering = true"
      @mouseleave="hovering = false"
    >
      <v-icon
        v-if="isEmpty"
        style="color: rgba(0,0,0,0.3);margin-bottom: 25px;"
        :style="hovering ? 'color: rgba(255,0,0,0.3) !important;' : ''"
        @click="dropRow"
      >{{hovering ? 'mdi-delete-empty' : 'mdi-delete-outline'}}</v-icon>
    </td>
    <td
      v-for="(subfieldtype, index) in fieldType.subfieldtypes"
      :key="subfieldtype.id"
      :style="{ width: colWidth + '%' }"
      style="position:relative;"
    >
      <AnswerField
        :userFormId="userFormId"
        :question="question"
        :fieldType="subfieldtype"
        :listId="listId"
        :isEmpty="isEmpty"
        @update:listId="$emit('update:listId', arguments[0])"
      />
    </td>
  </tr>
</template>

<script>
import { mapGetters } from 'vuex'
import AnswerField from './AnswerField'
import answerListMixin from '@/components/global/answerlistmixin'

export default {
  name: 'AnswerListTableRow',
  props: [ 'userFormId', 'question', 'fieldType', 'listId', 'colWidth' ],
  mixins: [ answerListMixin ],
  components: {
    AnswerField
  },
  data () {
    return {
      isClient: true
    }
  },
  computed: {
    ...mapGetters('userform', [
      'isReadOnly'
    ])
  }
}
</script>

<style scoped>
  td {
    vertical-align: bottom;
    padding-right: 4px;
    border-bottom: rgba(0,0,0,0.2) 1px solid;
  }
</style>
